export default {
  meta: {
    title: '洞察报告',
    parentPath: ['/insight'],
    breadcrumbs: {
      path: ['/insight/list'],
      name: ['洞察列表'],
    },
  },
};
